<mat-drawer-container autosize style="background: white">

    <mat-drawer #drawer [mode]="'side'" position="end">
        <div class="container">
            <h3 class="padding-top-15">Filters</h3>
            <mat-divider></mat-divider>
            <br/>
            <button (click)="drawer.toggle()" mat-stroked-button>
                <mat-icon aria-hidden="false">close</mat-icon>
                Close
            </button>&nbsp;
            <button (click)="resetGrid()" mat-stroked-button color="accent">
                <mat-icon aria-hidden="false">refresh</mat-icon>
                Reset
            </button>
        </div>
    </mat-drawer>

    <mat-drawer-content style="padding-top: 15px">
        <h5 class="card-title text-muted">Locations</h5>
        <mat-divider></mat-divider>

        <div class="row">
            <div class="col col-lg-4">
                <form class="form-inline list-employee-search-header">
                    <mat-form-field class="toast-top-full-width" appearance="standard">
                        <mat-label>Search by name or ID in external system</mat-label>
                        <input type="text"
                               placeholder=""
                               aria-label="Search"
                               matInput
                               (input)="updateFilter()" [(ngModel)]="filters.searchQuery.value">
                    </mat-form-field>
                </form>
            </div>

            <div class="col col-lg-2 padding-top-10">
                <mat-checkbox style="padding-top: 20px" [(ngModel)]="hideInactive"
                              (change)="reset()">
                    Hide inactive
                </mat-checkbox>
            </div>
            <div class="col col-lg-5 padding-top-10">
                <mat-checkbox style="padding-top: 20px" [(ngModel)]="showFailedOnly"
                              (change)="reset()">
                    Show failed only
                </mat-checkbox>
            </div>
            <div class="col col-lg-1">
                <button mat-fab color="primary" (click)="openCreateDialog()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
        <mat-divider></mat-divider>

        <div class="table-container">
            <div class="table-loading-shade"
                 *ngIf="isLoadingResults">
                <mat-spinner [diameter]="50" *ngIf="isLoadingResults"></mat-spinner>
            </div>

            <div class="table-box">
                <table mat-table [dataSource]="data"
                       matSort matSortActive="acquiredOn" matSortDisableClear matSortDirection="desc">

                    <ng-container matColumnDef="vetSuccessLocationId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Vetsource ID</th>
                        <td mat-cell *matCellDef="let row">{{row.vetSourceId}}</td>
                    </ng-container>

                    <ng-container matColumnDef="vetSuccessLocationName" sticky>
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                        <td mat-cell *matCellDef="let row">{{row.name}}</td>
                    </ng-container>

                    <ng-container matColumnDef="netSuitePracticeId">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Netsuite ID</th>
                        <td mat-cell *matCellDef="let row">{{row.netSuiteId}}</td>
                    </ng-container>

                    <ng-container matColumnDef="active">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
                        <td mat-cell *matCellDef="let row">
                            <mat-icon *ngIf="row.active" class="font-18" color="accent">check</mat-icon>
                            <mat-icon *ngIf="!row.active" class="font-18">remove</mat-icon>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                        <td mat-cell *matCellDef="let row" [matTooltip]="row.errorMessage">
                            <span [ngClass]="row.status == 'FAILURE' ? 'red-notice cursor-default' : (row.status == 'SUCCESS' ? 'green-notice' : '')"> {{row.status}} </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="loadDate">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>Load Date</th>
                        <td mat-cell *matCellDef="let row">{{row.loadDate}}</td>
                    </ng-container>

                    <ng-container matColumnDef="star" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button [matMenuTriggerFor]="menu" class="example-icon">
                                <mat-icon *ngIf="!element.loading">more_vert</mat-icon>
                                <mat-spinner *ngIf="element.loading" diameter="20"></mat-spinner>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="openViewDialog(element)">
                                    <mat-icon>remove_red_eye</mat-icon>
                                    <span>View</span>
                                </button>
                                <button *ngIf="!element.active" mat-menu-item (click)="openActivateDialog(element)">
                                    <mat-icon>check</mat-icon>
                                    <span>Activate</span>
                                </button>
                                <button *ngIf="element.active" mat-menu-item (click)="openActivateDialog(element)">
                                    <mat-icon>remove</mat-icon>
                                    <span>Deactivate</span>
                                </button>
                                <button mat-menu-item (click)="openCreateDialog(element)" [disabled]="!element.editable">
                                    <mat-icon>edit</mat-icon>
                                    <span>Edit</span>
                                </button>
                                <button mat-menu-item (click)="openDeleteDialog(element)">
                                    <mat-icon>delete</mat-icon>
                                    <span>Delete</span>&nbsp;
                                </button>
                            </mat-menu>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                </table>

            </div>

            <mat-paginator [length]="resultsLength" [pageSize]="pageSize"
                           [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
        </div>

    </mat-drawer-content>
</mat-drawer-container>
